import { render, staticRenderFns } from "./VehicleInsurancePartial.vue?vue&type=template&id=7f6c32be"
import script from "./VehicleInsurancePartial.vue?vue&type=script&lang=js"
export * from "./VehicleInsurancePartial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports